import { html, LonaWebComponent } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css, Style } from "@tento-ui/component-styles";
import { Typography } from "@tento-ui/ui/typography";
import { NaiveDate } from "@tento-chrono";
import { LonaApi } from "../../api";
import { getWeatherIconPath } from "@tento-ui/components/weather/weather-icon-map";
import { RowKey } from "@tento-lona/sheets";
import { WeatherDay } from "../weather-day";

@component({
  name: "lona-weather-accessory",
})
export class WeatherAccessory extends LonaWebComponent {
  private $icon: HTMLImageElement = this.$("icon") as HTMLImageElement;
  private $temp: HTMLElement = this.$("temp");

  static makeWith(props: WeatherAccessory.Props): WeatherAccessory {
    const $c = WeatherAccessory.make();
    $c.bind(props);
    return $c;
  }

  bind(props: WeatherAccessory.Props): this {
    this.$icon.style.display = "none";
    this.$temp.textContent = "";

    void this.fetchWeather(props.lid, props.date);

    return this;
  }

  private async fetchWeather(lid: number, date: NaiveDate): Promise<void> {
    const get: WeatherDay.Get = (rowKey, start, end) =>
      LonaApi.get("/api/rows/{rowKey}/cells", {
        path: { rowKey },
        query: {
          start,
          end,
          mock_sync_delay: null,
          booking_id: null,
        },
      });
    const weatherDay = await WeatherDay.read(get, lid, date).catch(() => null);


    if (weatherDay) {
      const temp = Math.round(weatherDay.avgtempF);
      const code = weatherDay.condition.code;
      const iconPath = getWeatherIconPath(code, true);

      this.$icon.src = iconPath;
      this.$icon.style.display = "block";
      this.$temp.textContent = `${temp}°`;
    }
  }

  static $styles: Style.Compat[] = [
    Typography.$style,
    css`
      :host {
        display: block;
        align-self: stretch;
        height: 100%;
        padding-inline: 8px;
        background: var(--bg);
        border-radius: 8px;
        height: 32px;
        box-shadow: var(--box-shadow-very-light);
        min-width: 72px;
        justify-content: center;
      }

      #root {
        align-items: center;
        gap: 6px;
        height: 100%;
      }

      #icon {
        width: 24px;
        height: 24px;
        object-fit: contain;
      }

      #temp {
        color: var(--text-sec);
        --font-size: var(--small-size);
        white-space: nowrap;
      }
    `,
  ];

  static $html: Option<HTMLTemplateElement> = html`
    <std-row id=root>
      <img id="icon" alt="" width="24" height="24" />
      <p id="temp" class="small"></p>
    </std-row>
  `;
}

export namespace WeatherAccessory {
  export interface Props {
    lid: number;
    date: NaiveDate;
  }
}
